import { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { SessionContext } from "../SessionContext";

const RequireAuth = () => {
  const { user } = useContext(SessionContext);
  const location = useLocation();

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
};

export default RequireAuth;
